import { render } from "./Card.vue?vue&type=template&id=2face173&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=2face173&lang=scss&scoped=true"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2face173"]])

export default __exports__